import { ApiService, toBodyModel, toModel } from '~/shared/api'
import type { QueryParams } from '~/shared/interfaces/params'
import {
  DigitalLectureFilters,
  DigitalLectureVideoListResult,
  DigitalLectureSpeakerListResult,
  DigitalLectureSpeakerDetail,
} from '~/models/digital-lecture'
import { API_PREFIX } from '~/shared/const/request-services'

export class DigitalLectureMainService extends ApiService {
  readonly urls = {
    videosFilters: `${API_PREFIX}/digital-lecture/filters`,
    videosList: `${API_PREFIX}/digital-lecture/videos`,
    viewedVideos: `${API_PREFIX}/users-management/digital-lecture/videos`,
    speakersFilters: `${API_PREFIX}/digital-lecture/speakers/filters`,
    speakersList: `${API_PREFIX}/digital-lecture/speakers`,
    speakerById: (id: number | string) => `${API_PREFIX}/digital-lecture/speakers/${id}`,
  }

  getVideosFilters(params: QueryParams = {}): Promise<DigitalLectureFilters> {
    return this.http
      .request({ url: this.urls.videosFilters, params })
      .then(toModel(DigitalLectureFilters))
  }

  getVideosList(params: QueryParams = {}): Promise<DigitalLectureVideoListResult> {
    return this.http
      .request({
        url: this.urls.videosList,
        params: { sort: '-date_publication', 'page[size]': 15, ...params },
      })
      .then(toBodyModel(DigitalLectureVideoListResult))
  }

  getViewedVideos(params: QueryParams = {}): Promise<DigitalLectureVideoListResult> {
    return this.http
      .request({ url: this.urls.viewedVideos, params })
      .then(toBodyModel(DigitalLectureVideoListResult))
  }

  getSpeakersFilters(params: QueryParams = {}): Promise<DigitalLectureFilters> {
    return this.http
      .request({ url: this.urls.speakersFilters, params })
      .then(toModel(DigitalLectureFilters))
  }

  getSpeakersList(params: QueryParams = {}): Promise<DigitalLectureSpeakerListResult> {
    return this.http
      .request({
        url: this.urls.speakersList,
        params: { 'page[size]': 30, ...params },
      })
      .then(toBodyModel(DigitalLectureSpeakerListResult))
  }

  getSpeakerById(id: number | string): Promise<DigitalLectureSpeakerDetail> {
    return this.http
      .request({ url: this.urls.speakerById(id) })
      .then(toModel(DigitalLectureSpeakerDetail))
  }
}
